var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-bottom":"40px"}},[_c('div',{staticClass:"main main-raised"},[_c('div',{staticClass:"container"},[_vm._m(0),_c('div',[_c('NewPago')],1),_c('div',{staticClass:"sharing-area text-center"}),_c('br')])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section text-center"},[_c('div',{staticClass:"features"})])
}]

export { render, staticRenderFns }